import { render, staticRenderFns } from "./WarehouseLayout.vue?vue&type=template&id=6ccd3c76"
import script from "./WarehouseLayout.vue?vue&type=script&lang=js"
export * from "./WarehouseLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports